import dayjs from 'dayjs';
import { uniqueId } from 'lodash';
import Defaults from '../Defaults';
import { genTodayStart, genTodayEnd } from '../Helper';
import { CreativeScheduleFormModel } from '.';
import { CampaignBudgetUtil } from '@/models/CampaignOperation/CampaignBudgetUtil';
var defaults = Defaults.CampaignBudget;
var TemporaryCampaignBudgetFormModel = /** @class */ (function () {
    function TemporaryCampaignBudgetFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, insertionOrderBudgetRequestId = _a.insertionOrderBudgetRequestId, _b = _a.budget, budget = _b === void 0 ? defaults.budget : _b, _c = _a.startTime, startTime = _c === void 0 ? genTodayStart() : _c, _d = _a.endTime, endTime = _d === void 0 ? genTodayEnd() : _d, _e = _a.pacingType, pacingType = _e === void 0 ? defaults.pacingType : _e, _f = _a.dailyLimitBudget, dailyLimitBudget = _f === void 0 ? defaults.dailyLimitBudget : _f, _g = _a.evenPacePercentage, evenPacePercentage = _g === void 0 ? defaults.evenPacePercentage : _g, _h = _a.creativeSchedules, creativeSchedules = _h === void 0 ? defaults.creativeSchedules : _h, _j = _a.deleted, deleted = _j === void 0 ? false : _j;
        this.tempId = uniqueId('temporaryCampaignBudget_');
        this.id = id;
        this.insertionOrderBudgetRequestId = insertionOrderBudgetRequestId;
        this.budget = budget;
        this.startTime = startTime;
        this.endTime = endTime;
        this.pacingType = pacingType;
        this.dailyLimitBudget = dailyLimitBudget;
        this.evenPacePercentage = evenPacePercentage;
        this.creativeSchedules = creativeSchedules.map(function (creativeSchedule) {
            return CreativeScheduleFormModel.assign(creativeSchedule);
        });
        this.deleted = deleted;
    }
    TemporaryCampaignBudgetFormModel.assign = function (data) {
        return new TemporaryCampaignBudgetFormModel(data);
    };
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "isNew", {
        get: function () {
            return this.id == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "canDelete", {
        get: function () {
            if (this.isNew)
                return true;
            var now = dayjs().startOf('hour');
            var start = dayjs(this.startTime);
            return start.isAfter(now);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "endDate", {
        get: function () {
            return this.endTime ? dayjs(this.endTime).format('YYYY-MM-DD') : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "noCreativesWarning", {
        get: function () {
            return this.creativeSchedules
                .map(function (cs) { return cs.noCreativesWarning; })
                .includes(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "isStartTimeAfterEndTime", {
        get: function () {
            return this.creativeSchedules
                .map(function (cs) { return cs.isStartTimeAfterEndTime; })
                .includes(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "isNotInCampaignBudgetPeriod", {
        get: function () {
            var _this = this;
            return this.creativeSchedules
                .map(function (cs) { return cs.isNotInCampaignBudgetPeriod(_this.startTime, _this.endTime); })
                .includes(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "isDateTimeMissing", {
        get: function () {
            return CampaignBudgetUtil.isDateTimeMissing(this.creativeSchedules, this.startTime, this.endTime);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "canEditStartTime", {
        /**
         * 開始日時が編集可能かどうか
         * 仮キャンペーン予算は常に真
         */
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TemporaryCampaignBudgetFormModel.prototype, "canEditEndTime", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TemporaryCampaignBudgetFormModel.prototype.resetCreativeSchedules = function () {
        this.creativeSchedules = [
            CreativeScheduleFormModel.assign(defaults.creativeSchedules),
        ];
    };
    TemporaryCampaignBudgetFormModel.prototype.delete = function () {
        if (!this.isNew) {
            this.deleted = true;
        }
    };
    return TemporaryCampaignBudgetFormModel;
}());
export { TemporaryCampaignBudgetFormModel };
